/**
 * 메인: 카테고리 목록
 *
 *
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Content, Title, Row, Col, Button } from 'components';
import { Flex, Tag } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { encrypt } from 'utils/Crypto';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 이벤트목록 컴포넌트
 * ----------------------------------------
 */
const EventList = ({
  screenSize,
  title = 'Event',
  path = '',
  data = [],
  dataKey = 'event',
  tag = 'Event',
}) => {
  /* ===== INIT ===== */
  const navigate = useNavigate();

  /* ===== STATE ===== */
  const [selected, setSelected] = useState(null);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  const List = React.useMemo(() => {
    if (!data.length) return [];

    const list = data?.slice()?.sort((a, b) => a?.order - b?.order);

    return list.slice(0, 5);
  }, [data]);

  React.useEffect(() => {
    if (!List.length) return;

    setSelected(List[0]);
  }, [List]);

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Content
      maxWidth={'100%'}
      backgroundColor="none"
      padding={screenSize >= 500 ? '80px 0' : '40px 0'}
      className="eventlist"
    >
      <Content
        maxWidth={1500}
        backgroundColor="none"
        padding={0}
        style={{
          margin: '0 auto',
        }}
      >
        {/* === 타이틀 === */}
        <Title
          style={{
            fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
            marginBottom: screenSize >= 768 ? 50 : 30,
            flexWrap: 'wrap',
            gap: screenSize >= 500 ? 0 : 20,
            alignItems: 'unset',
          }}
          className="dela-gothic"
          subButton={
            <Button
              className="goto"
              onClick={() => navigate(`/${path}`)}
              type="default"
            >
              바로가기 <RightOutlined />
            </Button>
          }
        >
          {title ?? '-'}
        </Title>

        {/* === 내용: start === */}
        <Row>
          <Col x={24}>
            <Flex
              vertical={screenSize > 1024 ? false : true}
              gap={24}
              flex={'0.7 0.3'}
            >
              <Content
                className="background_image"
                maxWidth={1480}
                backgroundColor="none"
                padding={0}
                style={{
                  margin: 0,
                  cursor: 'pointer',
                  width: '100%',
                  aspectRatio: '5 / 2.93',
                  borderRadius: 12,
                  border: '1px solid #f1f1f1',
                  background: selected
                    ? `url("${process.env.REACT_APP_STORE_URL}/${selected.thumbnail_url}") center center / cover no-repeat`
                    : '',
                  flex: 2,
                }}
                onClick={() =>
                  navigate(
                    `/${path}/${encodeURIComponent(
                      encrypt(selected[`${dataKey}_id`])
                    )}`
                  )
                }
              />

              <Flex vertical gap={12} flex={1}>
                {List.map((item, index) => (
                  <Content
                    key={`jm_${dataKey}_${item[`${dataKey}_id`]}_${index}`}
                    className="eventhover"
                    maxWidth={1480}
                    style={{
                      width: '100%',
                      // aspectRatio: '5/1.05',
                      height: 'calc((100% - 48px) / 5)',
                      borderRadius: 12,
                      border: '1px solid #f1f1f1',
                      opacity:
                        selected &&
                        selected[`${dataKey}_id`] === item[`${dataKey}_id`]
                          ? 1
                          : 0.5,
                      display: 'flex',
                      gap: screenSize >= 500 ? 5 : 0,
                      alignItems: 'center',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                      flex: 'none',
                    }}
                    onClick={() => setSelected(item)}
                  >
                    <div>
                      <Tag
                        style={{
                          backgroundColor: '#671A31',
                          color: 'var(--white-color)',
                          fontSize: screenSize >= 500 ? 15 : 13,
                          border: '1px solid var(--white-color)',
                          borderRadius: 20,
                          padding: screenSize >= 500 ? '5px 10px' : '3px 7px',
                        }}
                      >
                        <span
                          style={{
                            display: screenSize >= 500 ? 'unset' : 'none',
                          }}
                        >
                          {tag}
                        </span>{' '}
                        0{index + 1}
                      </Tag>
                    </div>
                    <Title
                      align={'left'}
                      color="#515151"
                      style={{
                        alignContent: 'center',
                        alignItems: 'center',
                        fontSize: screenSize >= 500 ? 18 : 14,
                        textOverflow: 'ellipsis',
                        webkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        fontFamily: 'Pretendard',
                      }}
                    >
                      {item[`${dataKey}_title`]}
                    </Title>
                  </Content>
                ))}
              </Flex>
            </Flex>
          </Col>
        </Row>
        {/* === 내용: end === */}
      </Content>
    </Content>
  ); // JSX: end
};

export default EventList;
